import { getThreadDetail, HOME_PAGE, NOTIFICATIONS } from 'src/constants/pages';
import { WeblabItem } from 'src/redux/slices/weblab';
import WeblabId from 'src/weblab/weblabId';
import WeblabTreatment from 'src/weblab/weblabTreatment';

type SSRPageConfig = {
  path: string
  weblabId: WeblabId
}[];

const SSR_PAGES_CONFIG: SSRPageConfig = [
  {
    path: NOTIFICATIONS,
    weblabId: WeblabId.SELLER_FORUMS_NOTIFICATIONS_SSR,
  },
  {
    path: getThreadDetail('[threadId]'),
    weblabId: WeblabId.SELLER_FORUMS_THREAD_DETAILS_SSR,
  },
  {
    path: HOME_PAGE,
    weblabId: WeblabId.SELLER_FORUMS_HOMEPAGE_SSR,
  },
];

const getIsSSRPage = (
  path: string,
  weblabList?: WeblabItem[],
): boolean => SSR_PAGES_CONFIG.findIndex((pageConfig) => pageConfig.path === path
        && weblabList
          ?.find((weblab) => weblab.id === pageConfig.weblabId
                && weblab.treatment === WeblabTreatment.T1)) >= 0;

export default getIsSSRPage;
